import { useMemo } from "react";
import { useFetch } from "../../../core/hooks/useFetch";
import { ApiFactory } from "../../../core/config/ApiFactory";
import { FidelidadeCards } from "../FidelidadeCards";
import { ICliente } from "../../../clientes/interface/ICliente";
import { ICupom } from "../../interface/ICupom";
import { IProdutoPedido } from "../../interface/IProdutoPedido";
import { ICategoria } from "../../../produtos/interfaces/ICategoria";

interface FidelidadeCardsWrapperProps {
    cliente: ICliente | undefined;
    cupons: ICupom[];
    aplicarCupom: (cupom: ICupom) => Promise<void>;
    adicionarProduto: (produto: IProdutoPedido) => void | Promise<IProdutoPedido | undefined>;
    categorias: ICategoria[];
    produtos: IProdutoPedido[];
}

export const FidelidadeCardsWrapper = ({
    cliente,
    cupons,
    aplicarCupom,
    adicionarProduto,
    categorias,
    produtos,
}: FidelidadeCardsWrapperProps) => {
    // Buscar programas de fidelidade ativos
    const apiEstabelecimento = useMemo(() => ApiFactory.getApi("MS_ESTABELECIMENTOS"), []);
    const { data: programasFidelidade } = useFetch(apiEstabelecimento, '/programas-fidelidade?ativo=true');
    
    // Filtrar apenas programas ativos
    const programasAtivos = useMemo(() => {
        if (!programasFidelidade) return [];
        const programas = Array.isArray(programasFidelidade) ? programasFidelidade : [];
        return programas.filter((programa: any) => programa.ativo === true);
    }, [programasFidelidade]);

    // Programas do cliente
    const programasCliente = useMemo(() => {
        return cliente?.programasFidelidade || [];
    }, [cliente]);

    if (!cliente || programasAtivos.length === 0 || programasCliente.length === 0) {
        return null;
    }

    // Wrapper para garantir que adicionarProduto sempre retorne uma Promise
    const adicionarProdutoWrapper = async (produto: IProdutoPedido): Promise<IProdutoPedido | undefined> => {
        const resultado = adicionarProduto(produto);
        // Se já é uma Promise, retorna ela, senão retorna Promise resolvida com undefined
        if (resultado instanceof Promise) {
            return resultado;
        }
        return Promise.resolve(undefined);
    };

    return (
        <FidelidadeCards
            programasAtivos={programasAtivos}
            programasCliente={programasCliente}
            cupons={cupons}
            aplicarCupom={aplicarCupom}
            adicionarProduto={adicionarProdutoWrapper}
            categorias={categorias}
            produtos={produtos}
        />
    );
};

